import classNames from 'classnames';
import React from 'react';

import css from './IconHomeware.module.css';

const IconHomeware = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        d="M25.333 24.25H20v-13.5a.5.5 0 0 0-.5-.5h-3V8.94a2.833 2.833 0 0 0 2.333-2.782c0-1.457-2.229-3.682-2.483-3.931a.5.5 0 0 0-.699 0c-.254.249-2.483 2.474-2.483 3.931a2.832 2.832 0 0 0 2.333 2.782v1.31h-3a.5.5 0 0 0-.5.5v13.5H6.667a.5.5 0 0 0-.5.5v2.588a2.58 2.58 0 0 0 2.578 2.578h14.51a2.58 2.58 0 0 0 2.578-2.578V24.75a.5.5 0 0 0-.5-.5zM14.167 6.157c0-.683 1.014-1.986 1.833-2.858.819.872 1.833 2.176 1.833 2.858A1.83 1.83 0 0 1 16.5 7.912V7.25a.5.5 0 0 0-1 0v.662a1.83 1.83 0 0 1-1.333-1.755zM13 11.25h1.333v4.167a.5.5 0 0 0 1 0V11.25h1.334v1.833a.5.5 0 0 0 1 0V11.25H19v13h-6v-13zm11.833 16.088a1.58 1.58 0 0 1-1.578 1.578H8.745a1.58 1.58 0 0 1-1.578-1.578V25.25h17.666v2.088z"
        fill="#011602"
      />
    </svg>
  );
};

export default IconHomeware;
